import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from '../services/ApiService';
import Loader from '../components/Loader';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [type, setType] = useState('user');
    const [isLoader, setIsLoader] = useState(false);
    const navigate = useNavigate();
    const [isCustomer, setIsCustomer] = useState(false);
    
    useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('role') === 'customer') {
        setIsCustomer(true);
        setType(params.get('role'));
    }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoader(true);
        try {
            const response = await ApiService.request({
                method: 'POST',
                url: '/forgot-password',
                data: { email, type },
            });
            if (response.data.status) {
                toast.success(response.data.message);
                navigate('/login');
            } else {
                toast.error(response.data.message || 'Failed to send reset link');
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to send reset link');
        } finally {
            setIsLoader(false);
        }
    };

    return (
        <div className="page-body-wrapper full-page-wrapper bg-light">
            <div className="row w-100 m-0 full-page-wrapper">
                <div className="content-wrapper full-page-wrapper d-flex align-items-center auth">
                    <div className="col-lg-4 mx-auto">
                        <div className="card">
                            <div className="card-body px-5 py-5">
                                <div className="text-center my-3">
                                    <h3 className="card-title mb-0 fs-2">Forgot Password</h3>
                                    <p>Enter your email to receive a reset link.</p>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group my-4">
                                        <label>Email *</label>
                                        <input
                                            type="email"
                                            required
                                            autoComplete="off"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="form-control p_input"
                                            placeholder="Email"
                                        />
                                    </div>
                                    {/* <div className="form-group my-4">
                                        <label>Account Type *</label>
                                        <select
                                            className="form-select"
                                            value={type}
                                            onChange={(e) => setType(e.target.value)}
                                        >
                                            <option value="user">Staff / Admin</option>
                                            <option value="customer">Customer</option>
                                        </select>
                                    </div> */}
                                    <div className="text-center">
                                        <button type="submit" className="btn btn-base w-100 mt-4" disabled={isLoader}>
                                            {isLoader ? <Loader /> : 'Send Reset Link'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;

